module.exports = __webpack_public_path__ + "img/zl3.cd5f2789.jpg";